import { Reveal } from '@progress/kendo-react-animation';
import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { ChevronDownOutline, ChevronUpOutline } from '../../../../../../icons/icons';
import MarkerText from '../../../../../components/inputs/MarkerText';
import { useSearchContext } from '../../../context/SettingsSearchContext';
import { SettingElement } from '../elements/SettingElement';
import { SettingsGroupType } from '../types';
import './SettingsGroup.css';

export function SettingsGroup(props: { group: SettingsGroupType }) {
    const [expanded, setExpanded] = React.useState(true);
    const context = useSearchContext();
    return (
        <div id={props.group.id}>
            <div
                className="d-flex justify-content-between align-items-center cursor-pointer bg-color px-1"
                onClick={() => setExpanded(!expanded)}
                style={{ position: 'sticky', top: 52, zIndex: 101 }}>
                <MarkerText highlight={context.term}>{props.group.name}</MarkerText>
                <Button
                    fillMode={'flat'}
                    svgIcon={expanded ? ChevronUpOutline : ChevronDownOutline}
                    onClick={() => setExpanded(!expanded)}
                />
            </div>
            <Reveal className="w-100">
                {expanded && (
                    <div className="k-card settings-group-content d-flex m-1">
                        {props.group.type === 'custom' && props.group.element}
                        {props.group.type === 'normal' && (
                            <>
                                {props.group.elements.map((x, i) => (
                                    <SettingElement key={i} element={x} />
                                ))}
                            </>
                        )}
                    </div>
                )}
            </Reveal>
        </div>
    );
}
